const TOKEN_KEY = 'pm_growth_token';
const USER_KEY = 'pm_growth_user';

export interface AuthUser { username: string; full_name?: string | null; role: string }

export function getToken(): string | null {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function getStoredUser(): AuthUser | null {
  try { const raw = localStorage.getItem(USER_KEY); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
export function storeSession(token: string, user: AuthUser) {
  try { localStorage.setItem(TOKEN_KEY, token); localStorage.setItem(USER_KEY, JSON.stringify(user)); } catch { /* ignore */ }
}
export function clearSession() {
  try { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); } catch { /* ignore */ }
}
export function authHeaders(): Record<string, string> {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
/** Called by every API client on a 401: drop the session and send the user to the login screen. */
export function handleUnauthorized(res: Response) {
  if (res.status === 401) {
    clearSession();
    window.dispatchEvent(new CustomEvent('pm-auth-expired'));
  }
}
